module.exports = __webpack_public_path__ + "img/logo.29c293ae.svg";